<form [formGroup]="formGroup" class="w-full">
    <div style="text-align: center; margin-left: auto; margin-right: auto;" class="w-full md:w-6 ">

        <h3>{{ 'sipo.anything-else-to-add' | translate }}</h3>
        <p>{{ 'sipo.anything-else-to-add-info' | translate }}</p>

        <app-form-element [formGroup]="formGroup" [formId]="'message'" [formLabel]="'sipo.message' | translate"
                          [type]="FormTypes.TEXTAREA">
        </app-form-element>

        <p>&nbsp;</p>

        <p-chips styleClass="w-full"
            formControlName="observers"
            separator=";"
            [placeholder]="'sipo.observers' | translate">
        </p-chips>


<!--        <app-form-element [formGroup]="formGroup" [formId]="'observers'" [formLabel]="'sipo.observers' | translate"-->
<!--                          [type]="FormTypes.TEXT">-->
<!--        </app-form-element>-->

        <p>&nbsp;</p>
        <!--        <p-fileUpload mode="advanced" chooseLabel="Select file" chooseIcon="pi pi-upload" name="demo[]"-->
        <!--                      url="https://www.primefaces.org/cdn/api/upload.php" (onUpload)="onUpload($event)"-->
        <!--                      [multiple]="true" accept=".pdf" maxFileSize="10000000">-->
        <!--        </p-fileUpload>-->

        <p-fileUpload
            mode="advanced"
            [chooseLabel]="'sipo.select-file-button' | translate"
            chooseIcon="pi pi-upload"
            name="demo[]"
            [files]="files"
            [auto]="true"
            [multiple]="true"
            accept=".pdf"
            maxFileSize="20000000"
            [customUpload]="true"
            (onSelect)="onFileSelect($event)"
            (onRemove)="removeFile($event)">
        </p-fileUpload>
    </div>
</form>
